export enum LiveClassFeedbackRatingQuestionTypes {
  MAIN = 283,
  REASONS = 284,
  OTHER = 449,
  RATING = 282,
  SEND_REASON = 283
}

export enum LiveClassFeedbackRatingOptionType {
  RATING_POSITIVE = 441,
  RATING_NEGATIVE = 442
}

export enum LiveClassFeedbackSendReasonOptionType {
  YES = 443,
  NO = 444
}



// WEBPACK FOOTER //
// ./ts/app/teacher-feedback/teacher-liveclass-feedback-modal/survey-questions-id.enum.ts